export const setCurrentForm= (state, val) => {
    state.currentForm = val;
}